<template>
  <div class="sellerinfo">
    <FormList
      :list="formList"
      :data="formData"
      :onChange="onInputChange"
    >
    </FormList>
  </div>
</template>

<script>
import FormList from '@components/FormList'
export default {
  components: {
    FormList
  },
  props: {
    currentCompany: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
    }
  },
  computed: {
    formList () {
      return [
        {
          type: 'info',
          field: 'name',
          label: '纳税人名称'
        },
        {
          type: 'info',
          field: 'taxNo',
          label: '纳税人识别号'
        },
        {
          type: 'info',
          field: 'address',
          label: '地址'
        },
        {
          type: 'info',
          field: 'tel',
          label: '电话号码'
        },
        {
          type: 'info',
          field: 'bankName',
          label: '开户行名称'
        },
        {
          type: 'info',
          field: 'bankNo',
          label: '银行账号'
        }
      ]
    },
    formData () {
      return this.currentCompany
    }
  },
  watch: {},
  created () {},
  mounted () {},
  activated () {},
  updated () {},
  methods: {
    onInputChange ({ e, field }) {
      console.log(e, field)
    }
  }
}
</script>
<style lang="less" scoped src="./style.less"></style>
